
const mS2S = timeInMS => timeInMS / 1000.0;

// All values are in seconds
class TimingInfo {
    protected _startTime : number;
    protected _lastFrameTime : number;
    protected _timeAtPause:number;
    protected _timeAtResume:number;
    protected _paused:boolean = false;
    protected _cumPausedDuration:number = 0;

    constructor(startTime ?: Date) {
        if (startTime != undefined){
            this._startTime = startTime.getTime()/1000;
            this._lastFrameTime = startTime.getTime()/1000;
        } else {
            this.reset();
        }
    }
    public pause(){
        this._paused = true;
        this._timeAtPause = new Date().getTime()/1000;
    }
    public resume(){
        this._paused = false;
        this._timeAtResume = new Date().getTime()/1000;
        this._cumPausedDuration += this._timeAtResume - this._timeAtPause;
    }
    // the time that the sim was started
    public get startTime() : number {
        return this._startTime;
    }
/*
    get startTime_S() : number {
        return mS2S(this.startTime_mS);
    }
*/
    // the time since the sim started (in seconds)
    public get elapsedTime() : number{
        if (this._paused){
            return this._timeAtPause - this._startTime - this._cumPausedDuration;
        } else {
            return new Date().getTime()/1000 - this._startTime - this._cumPausedDuration; ///Date.getTime returns milliseconds since 1970
        }
    }
    public pauseAtElasedTime(val:number){
        this.pause();
        // Tweak the _cumPausedDuration so that ET will respond at this value
        // ET = this._timeAtPause - this._startTime - this._cumPausedDuration;
        this._cumPausedDuration = -val + this._timeAtPause - this._startTime;
    }
    public get paused():boolean{
        return this._paused;
    }
/*
    get elapsedTime_S() : number {
        return mS2S(this.elapsedTime_mS);
    }
*/
    // current time
    get now() : number {
        return new Date().getTime()/1000;
    }
/*
    get now_S() : number {
        return mS2S(this.now_mS);
    }
*/
    // last frame time - basically the time that the last frame finished
    /*
    get lastFrameTime_mS() : number {
        return this._lastFrameTime_mS;
    }
    */
    get lastFrameTime() : number {
        return this._lastFrameTime;
    }

    // time since the last frame
    get deltaTime() : number {
        return this.now - this._lastFrameTime; 
    }
/*
    get deltaTime_S() : number {
        return mS2S(this.deltaTime_mS);
    }
*/
    public reset(){
        this._startTime = this.now;
    }
    // marks the end of a frame/delta time
    public frameComplete(){
        this._lastFrameTime = this.now;
    }

    // makes it so that this is the amount that will happen on average per second
    // THIS DOES NOT MAKES SENSE - RB
    public perSecond(value : number) {
        return value * this.deltaTime;
    }

    public timeSince(value : Date | number) : number {
        if(value instanceof Date) {
            value = value.getTime()/1000;
        }
        return this.now - value;
    }
    /*
    public timeSince(value : Date | number) : number {
        return mS2S(this.timeSince_mS(value));
    }
    */
}

export default TimingInfo